<template>
  <div class="is-flex is-justify-content-center">
<!--    <b-tag type="is-warning is-light mb-1">-->
      <span
          class="gant-text is-centered is-size-7 is-inline-block is-clickable"
          @click="$emit('iconClicked');"
      >
        {{ label }}
      </span>
<!--    </b-tag>-->
  </div>
</template>

<script>
export default {
  name: "EditSearchLink",
  props:{
    label:{
      type: String,
      default: '',
    },
  }
}
</script>

<style scoped>

</style>